import { render, staticRenderFns } from "./WhatsTel.vue?vue&type=template&id=3ea38296&scoped=true&"
import script from "./WhatsTel.vue?vue&type=script&lang=js&"
export * from "./WhatsTel.vue?vue&type=script&lang=js&"
import style0 from "./WhatsTel.vue?vue&type=style&index=0&id=3ea38296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea38296",
  null
  
)

export default component.exports